import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useUrlParamGraphQl } from './useUrlParamGraphQl';

export const useIdGraphQl = (
  query,
  update,
  modifyUrlParams: (params: any) => any = () => ({}),
  idName = 'id'
) => {
  const { id } = useParams();
  const {
    loading,
    fetchError,
    fetchData: data,
    setQueryVariables,
    setUpdateVariables,
    updating,
    updateError,
    updateResponse,
  } = useUrlParamGraphQl(query, update, modifyUrlParams);

  useEffect(() => {
    if (id) {
      setQueryVariables({ [idName]: Number.parseInt(id) });
    }
  }, [id, setQueryVariables, idName]);

  return {
    data,
    loading,
    updating,
    fetchError,
    updateError,
    updateResponse,
    setUpdateVariables,
    setQueryVariables,
    id,
  };
};
